import { DateHelper } from "@swivl-mono/helpers";
import { LocationVarKey, ReviewInterface } from "@swivl-mono/types";
import { DateTime } from "luxon";
import { AiFillStar } from "react-icons/ai";

import { useLocationVariables } from "../../../../Hooks/useLocationVariables";
import "./Review.View.Header.scss";

interface Props {
  review: ReviewInterface;
}
export function ReviewViewHeader(props: Props) {
  const { review } = props;

  const variables = useLocationVariables([LocationVarKey.Name, LocationVarKey.Address, LocationVarKey.AvatarURL], undefined, review.locationId);

  let storeImage;
  if (variables?.[LocationVarKey.AvatarURL]) {
    storeImage = variables[LocationVarKey.AvatarURL];
  } else {
    storeImage = "https://swivl-cdn.s3-us-west-1.amazonaws.com/self_storage_hallway.jpg";
  }

  let platformImage;
  if (review.platform === "google") {
    platformImage = "https://swivl-cdn.s3-us-west-1.amazonaws.com/reviews/logo-google.png";
  } else if (review.platform === "yelp") {
    platformImage = "https://swivl-cdn.s3-us-west-1.amazonaws.com/reviews/logo-yelp.png";
  } else {
    platformImage = "https://swivl-cdn.s3-us-west-1.amazonaws.com/reviews/logo-spot.png";
  }

  return (
    <div className="ReviewViewHeader">
      <div className="left">
        <div className="platform">
          <img src={platformImage} alt={review.platform} />
        </div>
        <div className="rating">
          <AiFillStar className={review.rating >= 1 ? "on" : "off"} />
          <AiFillStar className={review.rating >= 2 ? "on" : "off"} />
          <AiFillStar className={review.rating >= 3 ? "on" : "off"} />
          <AiFillStar className={review.rating >= 4 ? "on" : "off"} />
          <AiFillStar className={review.rating >= 5 ? "on" : "off"} />
        </div>
        <div className="name">{review.reviewerIsAnonymous ? "Anonymous" : review.reviewerName}</div>
      </div>
      <div className="center">
        <div className="locationIcon">
          <img src={storeImage} />
        </div>
        <div className="locationName">{variables?.[LocationVarKey.Name] as any}</div>
        <div className="locationAddress">{variables?.[LocationVarKey.Address] as any}</div>
      </div>
      <div className="right">
        <div className="date">{DateHelper.dateTime(review.reviewDate).toLocaleString(DateTime.DATE_FULL)}</div>
      </div>
    </div>
  );
}
